const useStyles = {
  formControl: {
    minWidth: 359,
  },
  downloadButton: {
    marginTop: '12px',
  },
  alert: {
    width: '100%',
  },
};

export { useStyles };
